import { memo } from 'react';
import { SimpleStatisticCardData } from 'components/statistic-card/StatisticCardData';



interface SimpleStatisticCardProps {
	data: SimpleStatisticCardData,
	onClick?: () => void,
}


const SimpleStatisticCard = (props: SimpleStatisticCardProps) => {
	const { onClick } = props;
	const { label, value, state } = props.data;


	const getStateClass = (state: 'danger' | 'warning' | 'success' | null | undefined) => {
		if (state === 'danger') return ' state-danger';
		if (state === 'warning') return ' state-warning';
		if (state === 'success') return ' state-success';
		return '';
	};

	return (
		<div className={`component-statistic-card simple-statistic-card${getStateClass(state)}`}
			onClick={() => onClick !== null && onClick !== undefined ? onClick() : {}}>
			
			<p className='card-name'>{label ? label : ''}</p>
			
			<p className='card-value'>
				{value !== undefined && value !== null ? value : '-'}
			</p>
		</div>
	);
}

export default memo(SimpleStatisticCard);